
export default {
  name: "DialogHeader",
  props: {
    title: {
      type: String,
    }
  }
}
